<template>
	<BottomSheet title="Shop" v-model="openProductList">
		<ul class="product-list">
			<li
				class="product-list__item"
				v-for="product in products"
				:key="product.id"
				@click="openProduct(product)"
			>
				<div class="product-list__item-image flex-center">
					<img :src="product.image" />
				</div>
				<div class="product-list__item-content">
					<p class="product-list__item-title">
						{{ product.name }}
					</p>
					<p class="product-list__item-price">
						{{ getProductPrice(product).toLocaleString("en-US") }}
						{{ currency }}
					</p>
				</div>
			</li>
			<li
				class="product-list__item"
				v-for="index in skeletons"
				:key="`skeleton-${index}`"
			>
				<div class="product-list__item-image flex-center">
					<div class="skeleton" style="width: 100%; height: 100%"></div>
				</div>
				<div class="product-list__item-content">
					<div class="skeleton" style="width: 70%"></div>
					<div class="skeleton" style="width: 20%"></div>
				</div>
			</li>
		</ul>
	</BottomSheet>
</template>

<script setup>
import { SHORT_VIDEO_TRACKING_TYPE } from "@/configs/constants";
import { $productDetail, $productExternalDetail } from "@/store/cart";
import { useCartIntegration } from "@/vue/composables/useCartIntegration";
import { computed } from "vue";
import globalSettings from "~/core/global-settings";
import BottomSheet from "../shared/BottomSheet.vue";
const {
	products,
	openProductDetail,
	openProductExternalDetail,
	openProductList,
	loading,
	videoTracking,
	currency,
} = useCartIntegration();

const skeletons = computed(() => (loading.value ? 4 : 0));

function getProductPrice(product) {
	if (product.variants?.length > 0) {
		const variant = product.variants[0];
		return variant.promotionPrice > 0 ? variant.promotionPrice : variant.price;
	} else {
		return product.promotionPrice > 0 ? product.promotionPrice : product.price;
	}
}

function openProduct(product) {
	globalSettings.trackingIOT(
		SHORT_VIDEO_TRACKING_TYPE.CTA_CLICK,
		videoTracking.value?.playlistId,
		videoTracking.value?.videoItem,
		videoTracking.value?.tagName,
		videoTracking.value?.orgId,
		product.productLink,
		product.id
	);
	if (!product?.isUsingCartIntegrated) {
		if (product.description) {
			$productExternalDetail.set({ ...product });
			openProductExternalDetail.value = true;
		} else {
			window.open(product.productLink, "_blank");
		}
		return;
	}
	$productDetail.set({ ...product });
	openProductDetail.value = true;
}
</script>
